import { AxiosResponse } from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import { GetOnePrivacyPolicyDTO } from "../../constants/dto/privacy-policy";
import {
  setPrivacyPolicy,
  setPrivacyPolicyActionStart,
  setPrivacyPolicyErrorMessage,
} from "../../constants/reducers/privacy-policy.reducer";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { store } from "../../store";
import { createCall } from "../base";

type GetPrivacyPolicyProp = {
  id: number;
};

let body: GetOnePrivacyPolicyDTO;

export const getOnePrivacyPolicy = async ({ id }: GetPrivacyPolicyProp) => {
  store.dispatch(setPrivacyPolicyActionStart(true));
  const queryParams = new URLSearchParams();

  if (id) queryParams.append("id", id.toString());

  const request = await createCall(
    "cms/privacy-policies/get-one",
    BASE_METHODS.GET,
    "application/json",
    "1.0.0",
    undefined,
    queryParams,
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetOnePrivacyPolicyDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setPrivacyPolicyErrorMessage(
          TextEnum.GET_ONE_PRIVACY_POLICY_INVALID_RESPONSE,
        ),
      );
      return null;
    }
    store.dispatch(
      setPrivacyPolicy({ privacyPolicy: response.data.privacyPolicy }),
    );
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponseData: CustomErrorType = responseError.response?.data;
    if (errorResponseData) {
      let errorMessage = "";
      switch (errorResponseData.code) {
        case 2001:
          errorMessage = TextEnum.GET_ONE_PRIVACY_POLICY_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setPrivacyPolicyErrorMessage(errorMessage));
      return null;
    }
    store.dispatch(setPrivacyPolicyActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
